import React from 'react';
import { ArrowRight } from 'lucide-react';
export function FinalCTASection() {
  return <section className="py-24 bg-white text-center" data-id="element-2">
      <div className="max-w-4xl mx-auto px-4" data-id="element-3">
        <h2 className="font-heading text-4xl md:text-5xl font-bold text-[#2C1810] mb-6" data-id="element-4">
          No necesitas más tiempo. <br data-id="element-5" />
          <span className="text-[#D4522A]" data-id="element-6">Necesitas un mejor plan.</span>
        </h2>
        <p className="font-body text-xl text-gray-600 mb-10 max-w-2xl mx-auto" data-id="element-7">
          Deja de sufrir con dietas que no son para ti. Empieza a disfrutar tus
          cenas y tu cuerpo hoy mismo.
        </p>

        <button onClick={() => document.getElementById('pricing')?.scrollIntoView({
        behavior: 'smooth'
      })} className="bg-[#F5A623] hover:bg-[#E09612] text-[#2C1810] font-heading font-bold text-2xl px-10 py-5 rounded-lg shadow-xl transform transition hover:-translate-y-1 flex items-center justify-center gap-3 mx-auto" data-id="element-8">
          QUIERO EMPEZAR YA
          <ArrowRight className="w-6 h-6" data-id="element-9" />
        </button>

        <p className="mt-6 text-sm text-gray-500" data-id="element-10">
          Descarga digital inmediata • Acceso de por vida
        </p>
      </div>
    </section>;
}